module.exports = __webpack_public_path__ + "static/media/ecrire-message.20b11be6.png";